import { FunctionComponent } from "react";

import _ from 'lodash';

interface ICheckboxWithRegisterProps {
    labelText: string;
    register: Function;
    containerStyles?: string;
    labelStyles?: string;
}
                
const CheckboxWithRegister: FunctionComponent<ICheckboxWithRegisterProps> = ({ register, labelText, containerStyles, labelStyles }) => {
    const fieldName = _.camelCase(labelText?.replaceAll(' ', ''));

    return (
            <div className={`${containerStyles} flex items-center justify-center cursor-pointer`}>
            <input 
                type="checkbox" 
                className="form-checkbox h-3 w-3 accent-primary cursor-pointer" 
                {...register(fieldName)} 
            />
            <label className={`text-gray-900 font-medium ${labelStyles}`}>
                {labelText}
            </label>
        </div>
    )
}
export default CheckboxWithRegister;